module.exports = __webpack_public_path__ + "img/VN.fe680431.png";